import React from 'react';
import compact from 'lodash/compact';
import { Text } from 'roo-ui/components';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

const OccupantsSummary = ({ occupants, ...rest }) => {
  const { adults, children, infants } = occupants;

  const occupantsText = compact([
    adults && pluralize('adult', adults, true),
    children && pluralize('child', children, true),
    infants && pluralize('infant', infants, true),
  ]).join(', ');

  return (
    <Text data-testid="occupants-summary" {...rest}>
      {occupantsText}
    </Text>
  );
};

OccupantsSummary.propTypes = {
  occupants: PropTypes.shape({
    adults: PropTypes.number.isRequired,
    children: PropTypes.number.isRequired,
    infants: PropTypes.number.isRequired,
  }).isRequired,
};

export default OccupantsSummary;
